import { render, staticRenderFns } from "./NetworkWorkspace.vue?vue&type=template&id=5aafe8e5&scoped=true"
import script from "./NetworkWorkspace.vue?vue&type=script&lang=js"
export * from "./NetworkWorkspace.vue?vue&type=script&lang=js"
import style0 from "./NetworkWorkspace.vue?vue&type=style&index=0&id=5aafe8e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aafe8e5",
  null
  
)

export default component.exports